import { Component, Input, OnInit } from "@angular/core";
import { CvConfigurationService } from "src/app/reusables/services/cv-configuration.service";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import { ModuleManager } from "src/shared/models/module-manager";
import { TimeInterval } from "src/shared/models/module-manager/module-manager-settings.models";
import { SharedDataService } from "./kpi-trend-coaching-header.service";
import SlideoutSettingsManager from "src/shared/models/slideout-settings-manager";
import { GroupSelectorDTO } from "src/AngularJS/Reusables/group-selector.models";
import { Group } from "src/AngularJS/Models/group.model";
import { GroupSelectorService } from "src/app/reusables/group-selector/group-selector.service";
import { BaseGroupType } from "src/AngularJS/Models/group-type.model";

@Component({
    selector: "kpi-trend-coaching-header",
    templateUrl: "./kpi-trend-coaching-header.component.html",
    styleUrls: ["./kpi-trend-coaching-header.component.scss"],
})
export class KpiTrendCoachingHeaderComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    @Input() moduleKey: string;
    @Input() settingsManager: SlideoutSettingsManager;
    @Input() context?: {
        settingsSelectedInterval: TimeInterval;
        viewStateLoaded: () => boolean;
        onIntervalChange: () => any;
    };
    metricName: string = "";
    agents: { id: number; order: number; name: string }[] = [];
    tableData: { id: number; order: number; name: string }[] = []; // Data to populate the table
    intervalTypesMap = new Map<
        number,
        { id: number; order: number; name: string }
    >();
    public selectedAgentsDTO: GroupSelectorDTO = null;
    public dataReady = false;
    private tempSelectedAgents: number[] = [0];
    public empGroup1List: Map<number, Group>;

    constructor(
        private localizationService: CVLocalizationService,
        private config: CvConfigurationService,
        public service: SharedDataService,
        private groupSelectorService: GroupSelectorService
    ) {}

    async ngOnInit(): Promise<void> {
        this.buildIntervalTypesArr();
        const selectedMetrics =
            this.moduleManager.getModuleSettings()?.selectedMetrics;
        if (selectedMetrics && selectedMetrics.length > 0) {
            this.metricName = selectedMetrics[0]?.Name || "";
        }

        this.moduleManager.setOptions({
            onSettingsApplied: async (settings) => {
                if (this.tempSelectedAgents.length > 0)
                    settings.empSelectorDTO._SelectedGroup1IDList =
                        this.tempSelectedAgents;
                const allGroups = (
                    await this.groupSelectorService.loadFilteredGroups(
                        this.moduleKey,
                        BaseGroupType.Employee,
                        1
                    )
                ).data;
                this.empGroup1List = new Map(
                    allGroups[1].Groups.map((g) => [g.GroupID, g])
                );
                settings.empSelectorDTO._SelectedGroup1IDList =
                    settings.empSelectorDTO._SelectedGroup1IDList.filter((id) =>
                        this.empGroup1List.has(id)
                    );
                this.agentGroupsChanged(settings.empSelectorDTO);
            },
            hasRefresh: true,
            refreshType: null,
            onRefresh: async (isAutoRefresh) => {
                if (!isAutoRefresh) this.moduleManager.showLoader = true;
            },
        });
    }

    async buildIntervalTypesArr() {
        this.agents.push({ order: 1, id: TimeInterval.Hour, name: "Agent 1" });
        this.agents.push({ order: 2, id: TimeInterval.Day, name: "Agent 2" });
        this.agents.push({
            order: 3,
            id: TimeInterval.DayOfWeek,
            name: "Agent 3",
        });
        this.agents.push({ order: 4, id: TimeInterval.Week, name: "Agent 4" });
        this.intervalTypesMap = new Map(this.agents.map((i) => [i.id, i]));
    }

    /** updates the groupSelector in the component and the settings. Used in the following functions:
     *
     * @function intialGroupsLoaded()
     * @function agentGroupsChanged()
     */
    private updateGroupSelectors(e: GroupSelectorDTO) {
        this.selectedAgentsDTO = e;
    }

    // runs from front end after the end of createChart() via boolean flag dataReady
    public async initialGroupsLoaded(e: GroupSelectorDTO) {
        //will be implemented later
    }

    /** Only grab those agents whos IDs exist in e._SelectedGroup1IDList.
     * Used in the following functions:
     *
     * @function intialGroupsLoaded()
     * @function agentGroupsChanged()
     */
    private async getSelectedAgents(e) {
        let allSelected = [];
        const allGroups = (
            await this.groupSelectorService.loadFilteredGroups(
                this.moduleKey,
                BaseGroupType.Employee,
                1
            )
        ).data;
        this.empGroup1List = new Map(
            allGroups[1].Groups.map((g) => [g.GroupID, g])
        );
        allSelected = e._SelectedGroup1IDList.map((id) =>
            this.empGroup1List.get(id)
        );
        allSelected = allSelected.filter((selected) => selected != null);
        return allSelected;
    }

    // called whenever agent dropdown is changed AKA the groupSelector
    public async agentGroupsChanged(e: GroupSelectorDTO) {
        this.tempSelectedAgents = e._SelectedGroup1IDList;
        this.getSelectedAgents(e);
        this.moduleManager.requestPublishNeeded();
    }

    getSelectedInterval() {
        return this.intervalTypesMap.get(this.context.settingsSelectedInterval);
    }
}
